module.exports = __webpack_public_path__ + "media/img/themes/ticketinhotel-sing-in-logo-b5cbbe3460ba344ce23d7878f324eb97.png";